import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ContentViewComponent } from '@principle-theorem/ng-interactions';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { IClinicalNote } from '@principle-theorem/principle-core/interfaces';
import { DAY_MONTH_YEAR_FORMAT } from '@principle-theorem/shared';
import { MomentModule } from 'ngx-moment';

@Component({
  selector: 'pr-referral-clinical-note-display',
  imports: [NgCommonModule, MomentModule, ContentViewComponent],
  templateUrl: './referral-clinical-note-display.component.html',
  styleUrl: './referral-clinical-note-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralClinicalNoteDisplayComponent {
  readonly dateFormat = DAY_MONTH_YEAR_FORMAT;
  clinicalNote = input<IClinicalNote>();
}
